<template>
  <List />
</template>

<script>
import List from './comp.vue';

export default {
  provide() {
    return {
      listMode: 'individual'
    };
  },
  components: {
    List
  }
};
</script>
